import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AppConfig } from '../../../config';

@Injectable({
  providedIn: 'root',
})
export class RequestService {
  private loggedIn = false;
  private token: string;

  constructor(private http: HttpClient) {}

  setLoggedIn(loggedIn: boolean, token?: string): void {
    this.loggedIn = loggedIn;
    this.token = token;
  }

  request(method: string, route: string, data?: any): Observable<any> {
    if (method === 'GET') {
      return this.get(route, data);
    }

    if (method === 'DELETE') {
      return this.http.request(method, AppConfig.apiEndpoint + route, {
        responseType: 'json',
        observe: 'body',
      });
    }

    return this.http.request(method, AppConfig.apiEndpoint + route, {
      body: data,
      responseType: 'json',
      observe: 'body',
    });
  }

  get(route: string, data?: any, options?: any): Observable<any> {
    let params = new HttpParams();
    if (data !== undefined) {
      Object.getOwnPropertyNames(data).forEach((key) => {
        params = params.set(key, data[key]);
      });
    }

    return this.http
      .get(AppConfig.apiEndpoint + route, {
        ...options,
        params,
        observe: 'response',
      })
      .pipe(catchError(this.handleError));
  }

  handleError(error): any {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // alert(errorMessage);
    return throwError(errorMessage);
  }
}
